import classNames from 'classnames';
import React from 'react';
import styles from './ModeToggle.module.scss';

interface ModeToggleProps {
  left: string;
  right: string;
  leftActive: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

const ModeToggle = ({
  left,
  right,
  leftActive,
  onToggle,
  disabled = false,
}: ModeToggleProps) => {
  return (
    <button
      className={styles.button}
      type="button"
      onClick={onToggle}
      disabled={disabled}
    >
      <div
        className={classNames(styles.toggle, {
          [styles.disabled]: disabled,
        })}
      >
        <div
          className={classNames(styles.option, {
            [styles.active]: leftActive,
          })}
        >
          {left}
        </div>
        <div
          className={classNames(styles.option, {
            [styles.active]: !leftActive,
          })}
        >
          {right}
        </div>
      </div>
    </button>
  );
};

export default ModeToggle;
